import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "GearListPage" */
	'pages/intervention/Gear/GearListPage'));

export default [{ component, exact: true, path: '/gears' }];